import type { Machine } from '@/lib/types';

export interface GuestMachineLimit {
  error: string;
  existing_machine: Machine;
  /** False when the machine to give up is the one being forked. */
  can_replace: boolean;
}

/** The "you already have a demo machine" conflict, if that is what this is. */
export function guestMachineLimit(error: unknown): GuestMachineLimit | null {
  const data = (error as { status?: number; data?: unknown })?.data;
  if ((error as { status?: number })?.status !== 409 || !data || typeof data !== 'object') {
    return null;
  }
  const record = data as Record<string, unknown>;
  return record.existing_machine ? (record as unknown as GuestMachineLimit) : null;
}

/** Extract a human-readable message from any thrown/query error value. */
export function errorMessage(error: unknown): string {
  if (!error) return 'Something went wrong.';
  if (error instanceof Error) return error.message;
  if (typeof error === 'object') {
    const record = error as Record<string, unknown>;
    const candidate = record.message ?? record.error ?? record.detail;
    if (typeof candidate === 'string' && candidate.trim()) return candidate;
  }
  if (typeof error === 'string') return error;
  return 'Something went wrong.';
}
